export default __webpack_public_path__ + "static/media/Note-Taker.211f0c57.JPG";